import { createAsyncThunk } from '@reduxjs/toolkit';
import { TERMS_TYPES } from './types';
import { termsApi } from './api';

export const fetchTerms = createAsyncThunk(
  'terms/fetchTerms',
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await termsApi.getAllTerms(page, limit);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch terms');
    }
  }
);

export const createTerm = createAsyncThunk(
  TERMS_TYPES.CREATE_TERM,
  async (termData, { rejectWithValue }) => {
    try {
      const response = await termsApi.createTerm(termData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create term');
    }
  }
);

export const fetchTermDetails = createAsyncThunk(
  'terms/fetchTermDetails',
  async (termId, { rejectWithValue }) => {
    try {
      const response = await termsApi.getTermDetails(termId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch term details');
    }
  }
);

export const updateTerm = createAsyncThunk(
  'terms/updateTerm',
  async ({ termId, termData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await termsApi.updateTerm(termId, termData);
      // Refresh term details after update
      await dispatch(fetchTermDetails(termId));
      await dispatch(fetchTerms({ page: 1, limit: 0 }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update term');
    }
  }
);

export const deleteTerm = createAsyncThunk(
  'terms/deleteTerm',
  async (termId, { rejectWithValue, dispatch }) => {
    try {
      await termsApi.deleteTerm(termId);
      // Refresh terms list after deletion
      await dispatch(fetchTerms({ page: 1, limit: 0 }));
      return termId;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to delete term');
    }
  }
);

// Add other actions as needed
